<fieldset class="section-legend-border sub-section-legend col-md-12 col-lg-12" #Sensor >
    <legend class="section-legend-border">Sensor</legend>
<div class="row">
    <div class="col-sm-12">
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
            <div class="form-row">
                <div class="form-group col-md-7">
                    <ng-template #rt let-r="result" let-t="term">
                        {{ r.SensorName}}
                    </ng-template>
                    <label for="typeahead-basic">Search for a Sensor:</label>
                    <input id="typeahead-basic" type="text" class="form-control" name="sensorDataSensorModel.SensorDataSensorAutoComplete" [(ngModel)]="sensorDataSensorModel.SensorDataSensorAutoComplete" [ngbTypeahead]="search" [inputFormatter]="formatter" [resultTemplate]="rt" (selectItem)="selectedItem($event)"
                    />
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-2">
                    <label for="disabledTextInput">Sensor Id</label>
                    <input type="text" [(ngModel)]="sensorDataSensorModel.SensorID" name="sensorDataSensorModel.SensorID" placeholder="id" class="form-control">
                </div>
                <div class="form-group col-md-2">
                    <label for="disabledTextInput">Sensor Name</label>
                    <input type="text" [(ngModel)]="sensorDataSensorModel.SensorName" name="sensorDataSensorModel.SensorName" placeholder="Sensor Name" class="form-control">
                </div>
                <div class="form-group col-md-3">
                    <label for="disabledTextInput">Sensor Unique Name</label>
                    <input type="text" [(ngModel)]="sensorDataSensorModel.SensorUniqueName" name="sensorDataSensorModel.SensorUniqueName" placeholder="Sensor Unique Name" class="form-control">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-1"></div>
                <div class="form-group col-md-4 col-sm-12">
                    <button type="submit" class="btn btn-primary btn-block">Submit</button>
                </div>
            </div>
        </form>
    </div>
    <div class="col-sm-12">
        {{result}}
      </div>
</div>
</fieldset>